import { HomeHero, HomeSection1, HomeSection2 } from '../components'
import { ReactComponent as CurveGray } from '../assets/images/curve-3.svg'

const Home = () => {
  return (
    <main className="min-h-screen">
      <HomeHero />
      <HomeSection1 />
      <HomeSection2 />
      <CurveGray className="[&_path:first-of-type]:!fill-skin-fill [&_path:last-of-type]:!fill-gainsboro" />
    </main>
  )
}

export default Home
